module.exports = __webpack_public_path__ + "img/AMWETCarousel_sitOnFloor.a663e169.jpg";